import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {AuthGuard} from "../app-auth/guards/auth.guard";
import {LoginGeneralComponent} from "../app-auth/login/login-general/login-general.component";
import {ThemeInitializer} from "../common/services/theme.initializer";
import {AppMainComponent} from "./app-main.component";
import {EnvInitializer} from "../common/services/environement.initializer";

const defaultRoute = "selfscheduling";

const routes: Routes = [{
	path: "",
	component: AppMainComponent,
	children: [{
		path: "selfscheduling",
		loadChildren: () => import("./self.scheduling/self.scheduling.module").then(mod => mod.SelfSchedulingModule),
		canActivate: [AuthGuard],
		resolve: {
			initData: EnvInitializer
		}
	}, {
		path: "login",
		component: LoginGeneralComponent,
		resolve: {
			initData: ThemeInitializer
		},
		data: { title: "Login" }
	}, {
		path: "",
		pathMatch: "full",
		redirectTo: defaultRoute,
	},
// otherwise redirect to home
		{ path: "**", redirectTo: "" }]
}];

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		RouterModule.forChild(routes)
	],
	exports: [RouterModule],
	providers: []
})
export class AppMainRoutingModule { }
